import { render } from "./MainTable.vue?vue&type=template&id=2ade0a98&scoped=true"
import script from "./MainTable.vue?vue&type=script&lang=js"
export * from "./MainTable.vue?vue&type=script&lang=js"

import "./MainTable.vue?vue&type=style&index=0&id=2ade0a98&scoped=true&lang=scss"

import exportComponent from "/home/runner/work/linker-marketplace-web/linker-marketplace-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ade0a98"],['__file',"resources/js/components/logs-managment/index/MainTable.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2ade0a98"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2ade0a98', __exports__)) {
    console.log('reload')
    api.reload('2ade0a98', __exports__)
  }
  
  module.hot.accept("./MainTable.vue?vue&type=template&id=2ade0a98&scoped=true", () => {
    console.log('re-render')
    api.rerender('2ade0a98', render)
  })

}


export default __exports__